import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import assetify from "@quintype/framework/assetify";
import ResponsiveImageWithFallback from "../responsive-image-with-fallback";
import { generateImageSources, checkAppSlug } from "../../utils/utils";
import { getPagePath } from "../../../../isomorphic/data/collection";
import styles from "./styles.m.css";
import newmagazinetag from "../../../../assets/images/new-tag.png";
import { DeepBI } from "../../../../isomorphic/integrations";

export const HomePageMagazineCard = ({
  collection,
  hasTruncatedHeadline = true,
  cardWithImageZoom = true,
  className = "",
  type = "small",
  config
}) => {
  if (!collection) {
    return null;
  }

  const imageCaption = get(collection, ["metadata", "cover-image", "attribution"]);
  const coverImageS3Key = get(collection, ["metadata", "cover-image", "cover-image-s3-key"], "");
  const coverImageMetaData = get(collection, ["metadata", "cover-image", "cover-image-metadata"], "");
  const release = get(collection, ["release"], "");

  const checkSlug = checkAppSlug();
  let SourceLink = "";
  if (checkSlug) {
    SourceLink = getPagePath(collection, config);
  }

  return (
    <Link
      aria-label={`${"Read full story: "}`}
      className={`${styles["read-more-link"]} ${className} ${cardWithImageZoom ? "card-with-image-zoom" : ""}`}
      href={`${getPagePath(collection, config)}?pfrom=homepage-wrapper`}
      externalLink={SourceLink}
      callback={() => {
        DeepBI.PingMagazineClicked(collection);
      }}
    >
      {release && release && <img src={assetify(newmagazinetag)} alt="" className={styles["new-tag-img"]} />}

      <div className={styles["base"]}>
        <ResponsiveImageWithFallback
          className={styles["image-wrapper"]}
          slug={coverImageS3Key}
          metadata={coverImageMetaData}
          alt={imageCaption}
          imgParams={{ auto: ["format", "compress"] }}
          sources={generateImageSources(
            { aspectRatio: [1, 109], screenWidthCoverage: 5.5 },
            { aspectRatio: [81, 190], screenWidthCoverage: 6.1 }
          )}
        />
      </div>
    </Link>
  );
};

HomePageMagazineCard.propTypes = {
  hasTruncatedHeadline: PropTypes.bool,
  cardWithImageZoom: PropTypes.bool,
  className: PropTypes.string,
  config: PropTypes.object,
  type: PropTypes.string,
  story: PropTypes.shape({
    headline: PropTypes.string.isRequired,
    subheadline: PropTypes.string,
    slug: PropTypes.string.isRequired,
    "hero-image-metadata": PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number,
      "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
    }),
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string,
    authors: PropTypes.arrayOf(
      PropTypes.shape({
        "contributor-role": PropTypes.shape({
          name: PropTypes.string
        }),
        name: PropTypes.string
      })
    )
  }),
  collection: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      "cover-image-metadata": PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number
      }),
      "cover-image-s3-key": PropTypes.string,
      caption: PropTypes.string
    })
  })
};

export default HomePageMagazineCard;
